var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSpeak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6667,
    cy: 13.0007,
    r: 8.66667,
    stroke: "#513117",
    strokeWidth: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0026 37.916C39.0026 43.3008 39.0026 47.666 21.6693 47.666C4.33594 47.666 4.33594 43.3008 4.33594 37.916C4.33594 32.5312 12.0963 28.166 21.6693 28.166C31.2422 28.166 39.0026 32.5312 39.0026 37.916Z",
    stroke: "#513117",
    strokeWidth: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1641 4.33398C41.1641 4.33398 45.4974 6.93398 45.4974 13.0007C45.4974 19.0673 41.1641 21.6673 41.1641 21.6673",
    stroke: "#513117",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8359 8.66602C36.8359 8.66602 39.0026 9.96602 39.0026 12.9993C39.0026 16.0327 36.8359 17.3327 36.8359 17.3327",
    stroke: "#513117",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSpeak);
export default __webpack_public_path__ + "static/media/user-speak.c2e2030dc8269a197ae7922a28d7b2b9.svg";
export { ForwardRef as ReactComponent };